import { render } from "./Expandir.vue?vue&type=template&id=6b3dd0a5"
const script = {}
script.render = render

export default script